"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSensorRollupByDays = void 0;
const react_1 = require("react");
const useSensorEvents_1 = require("../useSensorEvents");
const SECONDS_PER_DAY = 24 * 60 * 60;
const useGetSensorRollupByDays = (sensorId, days = 7, rollupInSeconds) => {
    const { fetchSensorHistoricalState, loading } = (0, useSensorEvents_1.useSensorEvents)(undefined, sensorId);
    const [historicalData, setHistoricalData] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const fetchData = (0, react_1.useCallback)(async (sensorId, lookupDays, rollupInSeconds) => {
        setError(null);
        const now = Math.floor(Date.now() / 1000);
        const startTime = now - lookupDays * SECONDS_PER_DAY;
        const endTime = now;
        try {
            const data = await fetchSensorHistoricalState(sensorId, startTime, endTime, rollupInSeconds ?? SECONDS_PER_DAY);
            setHistoricalData(data);
        }
        catch (error) {
            setError(error);
            setHistoricalData(null);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (!sensorId) {
            return;
        }
        fetchData(sensorId, days, rollupInSeconds);
    }, [sensorId, days, rollupInSeconds]);
    return {
        historicalData,
        loading,
        error,
    };
};
exports.useGetSensorRollupByDays = useGetSensorRollupByDays;
